import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { QuestionsComponent } from './questions/questions.component';
import { StartComponent } from './start/start.component';
import { SummaryComponent } from './summary/summary.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { BlockUIModule } from 'ng-block-ui';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { PollComponent } from './poll/poll.component';
import { RouterModule } from '@angular/router';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { AuthStartPoll } from 'src/services/auth.startPoll';
import { Error404Component } from './error404-component/error404.component';
import { Error500Component } from './error500/error500.component';
import { DataService } from 'src/services/data.service';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import { Error401Component } from './error401-component/error401.component';
import { SafeHtmlPipe } from 'src/pipes/safeHtml.pipe';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    PersonalInformationComponent,
    QuestionsComponent,
    SummaryComponent,
    PollComponent,
    SafeHtmlPipe
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot([
      // {path: 'poll', component: PollComponent, canActivate: [AuthStartPoll]}, // Se puede ingresar siempre
      // {path: 'start', component: StartComponent, canActivate: [AuthStartPoll]},
      {path: 'poll/:idPollType/:campaign', component: PollComponent}, // Se puede ingresar siempre
      {path: 'start', component: StartComponent}, // Se puede ingresar siempre
      {path: 'personalInformation', component: PersonalInformationComponent, canActivate: [AuthStartPoll]}, // Se puede ingresar SÍ registerPoll == true && startPoll == false
      {path: 'questions', component: QuestionsComponent, canActivate: [AuthStartPoll]}, // Se puede ingresar SÍ registerPoll == true && startPoll == true && finishedPoll == false
      {path: 'summary', component: SummaryComponent, canActivate: [AuthStartPoll]}, // Se puede ingresar SÍ registerPoll == true && startPoll == true && finishedPoll == true
      {path: '', redirectTo: 'start', pathMatch: 'full'},
      {path: 'error500', component: Error500Component},
      {path: 'error401', component: Error401Component},
      { path: '**', component: Error404Component }
    ]),
    BlockUIModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatInputModule,
    MatCardModule,
    MatStepperModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatListModule,
    MatProgressSpinnerModule
  ],
  providers: [MatDatepickerModule, DataService, SafeHtmlPipe, { provide: MAT_DATE_LOCALE, useValue: 'es-AR' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
